const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_identity_pool_id: process.env.REACT_APP_IDENTITY_POOL_ID,
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: process.env.REACT_APP_USER_POOL,
  aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOL_CLIENT,
  oauth: {},
};

export default awsmobile;
